import * as d3 from 'd3'

export default {
  methods: {

    draw_SummaryTable() {

      this.canvasTable = this.svg
      .append('g')
      .attr('transform', `translate(20.5, 0.5)`)

      this.canvasTable
      .append('text')
      .attr('x', -10).attr('y', 20)
      .attr('font-size', 15).attr('fill', '#000')
      .text('Piping Spool Status')
      
      this.canvasTable
      .append('text')
      .attr('x', 0).attr('y', 50)
      .attr('font-size', 14).attr('fill', '#00bbf9')
      .text(this.chart.name)

      let refCol = 'ZONE'
      if (this.FilterValues.STAGE == 'ZONE') refCol = 'LEVEL'

      let data = this.tableData.find(f=> f[refCol] == 'TOTAL')

      let spool = [
        {name: 'Fabrication',  total: data.TOT, actual: data.FAB, color: '#BDBCBC', },
        {name: 'Installation', total: data.TOT, actual: data.IST, color: '#83D2F5', },
      ]

      let summaryBar = this.canvasTable
      .append('g')
      .attr('transform', `translate(0, 0)`)

      
      this.SummaryBar(summaryBar, 0, 70, spool[0])
      this.SummaryBar(summaryBar, 165, 70, spool[1])

      this.draw_TableHeader(95)
      this.draw_dataGrid(130)
    },

    SummaryBar(selection, _x, _y, _d) {
      let pro = 0
      let barLen = 150
      if(_d.actual > 0) pro = _d.actual/_d.total

      let barChart = selection
      .append('g')
      .attr('transform', `translate(${_x}, ${_y})`)

      barChart
      .append('text')
      .attr('x', 0).attr('y', 0)
      .attr('font-size', 11).attr('fill', '#333')
      .text(_d.name)

      barChart
      .append('rect')
      .attr('x', 0).attr('y', 4)
      .attr('width', barLen).attr('height', 13).attr('fill', '#E0E0DF').attr('opacity', .3)

      barChart
      .append('rect')
      .attr('x', 0).attr('y', 4)
      .attr('width', barLen * pro).attr('height', 13).attr('fill', _d.color).attr('opacity', 1)

      barChart
      .append('text')
      .attr('x', (pro>70) ? barLen * pro - 2 : barLen * pro + 2).attr('y', 14)
      .attr('font-size', 11).attr('fill', _d.color).attr('text-anchor', (pro>70) ? 'end' : 'start')
      .text((pro*100).toFixed(1) + '%')
    },


    draw_TableHeader(_y) {

      let header = this.canvasTable
      .append('g')
      .attr('transform', `translate(0, ${_y})`)

      header
      .append('line')
      .attr('x1', 0).attr('y1', 0).attr('x2', this.table.width).attr('y2', 0)
      .attr('stroke', '#757575').attr('stroke-width', .5)

      header
      .append('line')
      .attr('x1', this.table.style[1].ex).attr('y1', 20).attr('x2', this.table.width).attr('y2', 20)
      .attr('stroke', '#bcbcbc').attr('stroke-width', .5)

      header
      .append('line')
      .attr('x1', 0).attr('y1', 35).attr('x2', this.table.width).attr('y2', 35)
      .attr('stroke', '#757575').attr('stroke-width', .5)

      this.table.style.forEach((d,i)=> {
        if(i<2) {
          header
          .append('text')
          .attr('x', d.cx).attr('y', 12 + 11*0.75)
          .attr('font-size', 11)
          .attr('fill', '#333').attr('text-anchor', 'middle')
          .text(d.name)
        } else {
          header
          .append('text')
          .attr('x', d.cx).attr('y', 22 + 10*0.75)
          .attr('font-size', 10)
          .attr('fill', '#757575')
          .attr('text-anchor', 'middle')
          .text(d.name)
        }
        if(i < this.table.style.length-1) {
          header
          .append('line')
          .attr('x1', d.ex).attr('y1', (d.name=='WO') ? 20 : 0).attr('x2', d.ex).attr('y2', 35)
          .attr('stroke-width', .5).attr('stroke', (i==0) ? '#757575' : '#bcbcbc')
        }
      })

      header
      .append('text')
      .attr('x', this.table.style[2].ex).attr('y', 5 + 11*0.75)
      .attr('font-size', 11)
      .attr('fill', '#333').attr('text-anchor', 'middle')
      .text('Fabrication')

      header
      .append('text')
      .attr('x', this.table.style[4].ex).attr('y', 5 + 11*0.75)
      .attr('font-size', 11)
      .attr('fill', '#333').attr('text-anchor', 'middle')
      .text('Installation')
    },



    draw_dataGrid(_y) {

      let dataGrid = this.canvasTable
      .append('g')
      .attr('transform', `translate(0, ${_y})`)
      .attr('cursor', 'default')

      let y = 0
      this.tableData.forEach((row,r)=> {

        this.table.style.forEach((col,c)=> {

          dataGrid
          .append('text')
          .attr('x', (r == this.tableData.length-1 && c == 0) ? col.cx : col.tx).attr('y', y + 5 + 10*0.75)
          .attr('font-size', 10)
          .attr('fill', (r == this.tableData.length-1) ? '#333' : '#757575')
          .attr('text-anchor', (r == this.tableData.length-1 && c == 0) ? 'middle' : col.align)
          .attr('font-weight', 400)
          .text(row[col.code])
          .call(this.call_LINK, row, col)

          if(c < this.table.style.length-1) {
            dataGrid
            .append('line')
            .attr('x1', col.ex).attr('y1', y).attr('x2', col.ex).attr('y2', y + this.table.lineheight)
            .attr('stroke-width', .5).attr('stroke', (c==0) ? '#757575' : '#bcbcbc')
          }
        })

        if(y > 0) {
          dataGrid
          .append('line')
          .attr('x1', 0).attr('y1', y).attr('x2', this.table.width).attr('y2', y)
          .attr('stroke-width', .5)
          .attr('stroke', (r == this.tableData.length-1) ? '#757575' : '#bcbcbc')
        }

        y = y + 20
      })

      dataGrid
      .append('line')
      .attr('x1', 0).attr('y1', y).attr('x2', this.table.width).attr('y2', y)
      .attr('stroke', '#757575').attr('stroke-width', .5)
    },


  }
}